import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useAvatarUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();

  const uploadAvatar = async (file: File, userId: string): Promise<string | null> => {
    if (!file) return null;

    // Verificar se é imagem
    if (!file.type.startsWith('image/')) {
      toast({
        title: "Erro",
        description: "Apenas imagens são permitidas para foto de perfil",
        variant: "destructive"
      });
      return null;
    }

    // Verificar tamanho (máximo 5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      toast({
        title: "Erro", 
        description: "Imagem muito grande. Máximo 5MB permitido",
        variant: "destructive"
      });
      return null;
    }

    try {
      setIsUploading(true);
      
      const fileExt = file.name.split('.').pop();
      const fileName = `${userId}/avatar.${fileExt}`;
      
      // Upload para o bucket avatars
      const { data, error } = await supabase.storage
        .from('avatars')
        .upload(fileName, file, {
          contentType: file.type,
          upsert: true // Substitui se já existe
        });

      if (error) {
        console.error('Erro no upload do avatar:', error);
        toast({
          title: "Erro",
          description: "Erro ao fazer upload da foto de perfil: " + error.message,
          variant: "destructive"
        });
        return null;
      }

      // Obter URL pública
      const { data: publicData } = supabase.storage
        .from('avatars')
        .getPublicUrl(fileName);

      return publicData.publicUrl;
    } catch (error: any) {
      console.error('Erro no upload do avatar:', error);
      toast({
        title: "Erro",
        description: "Erro inesperado ao fazer upload da foto",
        variant: "destructive"
      });
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadAvatar, isUploading };
};